<template>

  <h3 class="smaller lighter grey"><i class="fa fa-spin fa-spinner"></i></h3>

</template>

<script>

export default {
  name: "TemplateLoading",
  components: {
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Template/TemplateLoading.vue